import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-admin-page-header',
  imports: [],
  templateUrl: './admin-page-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./admin-page-header.component.css'],
})
export class AdminPageHeaderComponent {}
